import {useTranslation} from "react-i18next";

export const InvalidValue = () => {
  const {t} = useTranslation();
  return <em>{t("control-card.value.invalid")}</em>;
};
